import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Typography, Button, InputNumber, message, Input } from 'antd';
import { XInfoLabel } from '@/components/xqxc_ui';
import SetArea from './modal/SetInfo';
import model from '@/reducers/system/operation/model';
import { XTitle } from '@/components/xqxc_ui';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import SettleSetting from './modal/SettleSetting';
import { regFenToYuan, regYuanToFen } from '@/util/money';
import * as apis from '@/apis/system/finance.js';

const { Title } = Typography;
const {TextArea} = Input;

const FinancialInfo = ({
    setBreadcrumbPaths,
    match,
    getSystemOperationInfo,
    systemOperationInfo: {
        acEmplInfoId = '',
        companyBaseInfo = {},
        companyFinancialBaseInfo = {},
        companyFinancialBaseInfo: {
            bankAccount = '',
            bankName = '',
            openBank = '',
            bankAccountName = '',
            deposit = 0,
            financialId = 0,
            feeJson = '[]',
            depositWhiteList = []
        } = {}
    } = {}
}) => {
    const [renderMode, setRenderMode] = useState(false);
    const [update, setUpdate] = useState(false);
    const [showSettleSetting, setShowSettleSetting] = useState(false);
    const [securityDeposit, setSecurityDeposit] = useState();  // 接单保证金
    const [whiteList, setWhiteList] = useState(depositWhiteList.join(',')); // 白名单

    const feeData = JSON.parse(feeJson || '[]') || [];

    useEffect(() => {
        getSystemOperationInfo();
        setBreadcrumbPaths(match); // 自动识别面包屑
    }, []);

    useEffect(()=>{
        setSecurityDeposit(regFenToYuan(deposit));
        setWhiteList(depositWhiteList.join(','));
    }, [companyFinancialBaseInfo]);

    useEffect(() => {
        if (update) {
            setUpdate(false);
            getSystemOperationInfo();
        }
    }, [update]);

    const container = {
        width: '100%',
        height: '100%',
        padding: '20px'
    };

    const infoStyle = {
        paddingLeft: '20px'
    };

    const onWhiteListChange = (e) => {
        let val = e.target.value || "";
        val = val.replace(/，/g, ',');
        setWhiteList(val.trim());
    };

    const setInfo = () => {
        setRenderMode(true);
    };

    const onSetSettle = () => {
        setShowSettleSetting(true);
    };

    const onSettleCancel = () => {
        setShowSettleSetting(false);
    };

    const onSettleOk = () => {
        getSystemOperationInfo();
        setShowSettleSetting(false);
    };

    const onDepositSave = ()=>{
        
        if (!securityDeposit && securityDeposit !== 0) {
            message.warn('请输入金额！');
            return false;
        }
        let whiteListStr = whiteList.replace(/，/g, ',');
        let _whiteList = whiteListStr ? whiteListStr.split(',') : [];
        _whiteList = _whiteList.filter(v=>v!=='');
        let params = {
            financialId: financialId,
            deposit: regYuanToFen(securityDeposit),
            companyId: companyBaseInfo.companyId,
            userId: acEmplInfoId,
            depositWhiteList: _whiteList
        };
        apis.setCompanyRiderDeposit(params).then(res => {
            message.success('保存成功！');
            setWhiteList(_whiteList.join(','));
        }).catch(err => {
            message.error(err.message);
        });
    };
    

    return <div style={container}>
        <div className={styles.section}>
            <div className={styles.sectionTitle}>
                <h2>收款账户信息</h2>
                <Button type="primary" onClick={setInfo}>设置</Button>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>银行账号</div>
                <div className={styles.val}>{bankAccount}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>户名</div>
                <div className={styles.val}>{bankAccountName}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>开户银行</div>
                <div className={styles.val}>{openBank}</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>开户支行</div>
                <div className={styles.val}>{bankName}</div>
            </div>
        </div>

        <div className={styles.section}>
            <div className={styles.sectionTitle}>
                <h2>结算设置</h2>
                <Button type="primary" onClick={onSetSettle}>设置</Button>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>平台服务费比例</div>
                {companyFinancialBaseInfo.platServiceFeeMode == 'RATIO' ? (
                    <div className={styles.val}>
                        <p>{companyFinancialBaseInfo.platServiceFeeValue}%</p>
                        <p>平台服务费 = 配送费(不含小费) * {companyFinancialBaseInfo.platServiceFeeValue}%</p>
                    </div>
                ) : (
                    <div className={styles.val}>
                        <p>{regFenToYuan(companyFinancialBaseInfo.platServiceFeeValue)} 元</p>
                    </div>
                )}
            </div>
            {feeData.length > 0 ? (
                <>
                    <div className={styles.item}>
                        <div className={styles.label}>众包骑手收益</div>
                        <div className={styles.val}>
                            <p>按里程远近设置</p>
                            <p style={{color: '#999'}}>骑手收益 = 配送费(不含小费) - 平台服务费 * 显示比例 + 小费</p>
                        </div>
                    </div>
                    <div className={styles.item} style={{paddingTop: 0}}>
                        <div className={styles.label}></div>
                        <div className={styles.val}>
                            <div  className={styles.kmsetting}>
                                {feeData.map((v, k) =>
                                    k == 0 ? (
                                        <p key={v.key}>
                                            从0公里增加至
                                            <strong>
                                                {v.distance / 1000}
                                            </strong>
                                            公里，众包骑手配送费按
                                            <strong>
                                                {v.riderRatio}%
                                            </strong>
                                            计算；
                                        </p>
                                    ) : (
                                        <p key={v.key}>
                                            里程增加至
                                            <strong>
                                                {v.distance / 1000}
                                            </strong>
                                            公里，众包骑手配送费按
                                            <strong>
                                                {v.riderRatio}%
                                            </strong>
                                            计算；
                                        </p>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className={styles.item}>
                    <div className={styles.label}>众包骑手收益</div>
                    <div className={styles.val}>
                        <p>按统一比例设置：{companyFinancialBaseInfo.riderRatio || '-'}%</p>
                        <p style={{color: '#999'}}>骑手收益 = 配送费(不含小费) - 平台服务费 * 显示比例 + 小费</p>
                    </div>
                </div>
            )}
        </div>

        <div className={styles.section}>
            <div className={styles.sectionTitle}>
                <h2>接单保证金</h2>
                <Button type="primary" onClick={onDepositSave}>保存</Button>
            </div>

            <div className={styles.item}>
                众包骑手(未绑定站点的骑手)在接单前需缴交
                <InputNumber addonAfter="元" className={styles.txt} value={securityDeposit} precision={2} min={0} max={999.99} placeholder="两位小数，0-999.99" onChange={e => { setSecurityDeposit(e); }} />
                保证金， 当发生需要骑手赔付的情形时可从骑手的保证金扣减。
            </div>
            <div className={styles.whiteListBox}>
                <div className={styles.label}>免缴白名单</div>
                <div className={styles.val}>
                    <TextArea
                        allowClear
                        value={whiteList}
                        onChange={onWhiteListChange}
                        className={styles.txts}
                        placeholder="输入骑手ID，以逗号分隔"
                    />
                </div>
            </div>
        </div>

        {renderMode && <SetArea setUpdate={setUpdate} setRenderMode={setRenderMode} companyFinancialBaseInfo={companyFinancialBaseInfo} companyBaseInfo={companyBaseInfo} />}
        {showSettleSetting && <SettleSetting companyFinancialBaseInfo={companyFinancialBaseInfo} onCancel={onSettleCancel} onOk={onSettleOk} />}
    </div>;
};

FinancialInfo.propTypes = {
    getSystemOperationInfo: PropTypes.func,
    systemOperationInfo: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect((state) => ({
    systemOperationInfo: state.systemOperation.systemOperationInfo,
}), {
    setBreadcrumbPaths,
    ...model.actions
})(FinancialInfo);